import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../../../api/userContext';
import { auth } from '../../../config/firebase';
import './ProfilePage.css';

const ProfilePage = () => {
  const { user, setUser, setIsAdmin } = useContext(UserContext);
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      setIsAdmin(null);
      history.push('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="contact-wrapper overflow-hidden">
      <div className="container mt-120 position-relative">
        <div className="row">
          <div className="col-lg-8">
            <form id="contact-form">
              <div className="contact-form-wrapper">
                <button type="button" className="btn btn-primary mb-4" onClick={handleLogout}>
                  Se déconnecter
                </button>
                <h4 className="contact-form-title">Profile</h4>
                <div className="profile-info mt-4">
                  {user && (
                    <>
                      <p className='item'><strong>Email:</strong> </p>
                      <p className='sub-item'>{user.email}</p>
                    </>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;